import { useCallback, useEffect, useState } from "react";
import tinycolor from "tinycolor2";
import { useCopyToClipboard } from "../../../../../../../hooks/index.js";
import { NO_COLOR } from "../../../../../constants.js";
import { useColorPicker } from "../../../../../hooks/useColorPicker.js";
function useHexInput(tooltipDuration = 1500) {
  const { onInvalidColor, value, onChange, localeText } = useColorPicker();
  const [textFieldValue, setTextFieldValue] = useState(() => value);
  useEffect(() => {
    setTextFieldValue(value === NO_COLOR ? localeText.noColorLabel : value);
  }, [value, localeText]);
  const onTextChange = useCallback(
    (event) => {
      const inputColor = event.target.value;
      setTextFieldValue(inputColor);
      const color = tinycolor(event.target.value);
      if (!color.isValid()) {
        onInvalidColor?.(inputColor);
        return;
      }
      const normalizeHex = normalizeHexColor(color.getFormat(), inputColor);
      onChange(null, normalizeHex);
    },
    [onChange, onInvalidColor]
  );
  const onBlur = () => {
    const color = tinycolor(textFieldValue);
    if (!color.isValid()) {
      setTextFieldValue(value === NO_COLOR ? localeText.noColorLabel : value);
    }
  };
  const [showCopied, setShowCopied] = useState(() => false);
  const [, copyToClipboard] = useCopyToClipboard({
    onSuccess: () => {
      setShowCopied(true);
    }
  });
  useEffect(() => {
    if (showCopied) {
      const timeout = setTimeout(() => {
        setShowCopied(false);
      }, tooltipDuration);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [showCopied, tooltipDuration]);
  const onClick = useCallback(() => {
    copyToClipboard(value);
  }, [value, copyToClipboard]);
  return {
    showCopied,
    onClick,
    textFieldValue,
    value,
    onTextChange,
    onBlur,
    readonly: false
  };
}
function normalizeHexColor(colorFormat, inputColor) {
  if (colorFormat !== "hex") return inputColor;
  return inputColor.startsWith("#") ? inputColor : `#${inputColor}`;
}
export {
  useHexInput
};
//# sourceMappingURL=useHexInput.js.map
